const GID_PATTERN = /^gid:\/\/gitlab\/[^/]+\/(\d+)$/;

export function gidToId(gid: string | null | undefined): number | undefined {
  const match = gid?.match(GID_PATTERN);

  return match ? Number(match[1]) : undefined;
}

export function idToGid(type: string, id: number | string): string {
  return `gid://gitlab/${type}/${id}`;
}
